wbApp.filter('paymentType', ['$translate', function ($translate) {
    return function (input) {
        switch (input) {
            case 0:
                return $translate.instant('TXT_VAL_PAYMENT_TYPE_BANK_TRANSFER');
            case 1:
                return $translate.instant('TXT_VAL_PAYMENT_TYPE_CASH');
            case 2:
                return $translate.instant('TXT_VAL_PAYMENT_TYPE_CREDIT_CARD');
            case 3:
                return $translate.instant('TXT_VAL_PAYMENT_TYPE_BENEFIT_PLUS');
            case 4:
                return $translate.instant('TXT_VAL_PAYMENT_TYPE_ONLINE');

        }
        
    };
}]);